export default __webpack_public_path__ + "static/media/DickTrooper.152bc4d0.PNG";